import React, { useEffect, useState } from 'react';
import api from '../../../../api';
import { useAuth } from '../../../Layouts/context/Authcontext';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';
import { BsClockFill, BsFillCalendar2CheckFill, BsCpuFill } from 'react-icons/bs';
import { FaUserClock, FaPercent, FaChartLine } from 'react-icons/fa';
import { MdOutlineAccessTime } from 'react-icons/md';
import { motion } from 'framer-motion';

const cardConfig = [
  { title: 'Total Employee Worked', icon: <FaUserClock />, dataKey: 'TotalFTEWorked' },
  { title: 'Expected Hours', icon: <BsClockFill />, dataKey: 'ExpectedHours' },
  { title: 'Biometric Hours', icon: <MdOutlineAccessTime />, dataKey: 'BiometricHours' },
  { title: 'EPR Hours | Downtime', icon: <BsCpuFill />, dataKey: 'EPRHours', secondaryKey: 'Downtime' },
    { title: 'Total Working Days', icon: <BsFillCalendar2CheckFill />, dataKey: 'Workeddays' },
  { title: 'Worked Days', icon: <BsFillCalendar2CheckFill />, dataKey: 'UniqueWorkingDays' },
  { title: 'Bio Efficiency', icon: <FaChartLine />, dataKey: 'Bioproductivity' },
   { title: 'Epr Efficiency', icon: <FaChartLine />, dataKey: 'Eprproductivity' },
];

const Top17Cards = ({ filters }) => {
  const { accessToken } = useAuth();
  const [cardData, setCardData] = useState({});
  const [lastUpdated, setLastUpdated] = useState('--');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCardStats = async () => {
      try {
        setLoading(true);
        const baseUrl = getRoundRobinBaseUrl();

        const filteredParams = {};
        Object.keys(filters).forEach((key) => {
          if (filters[key]) {
            filteredParams[key] = filters[key];
          }
        });

        const response = await api.get(`${baseUrl}/superadminDashboard/getDataFor17Cards`, {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: filteredParams,
        });

        if (response.data?.success) {
          setCardData(response.data.data || {});
          setLastUpdated(new Date().toLocaleString());
        }
      } catch (error) {
        console.error('Error fetching card data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (filters) {
      fetchCardStats();
    }
  }, [accessToken, filters]);

  const renderCard = ({ title, icon, dataKey, secondaryKey }, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.08 }}
      className="relative group p-6 bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300"
    >
      {/* Left Red Ribbon */}
      <div className="absolute top-0 left-0 h-full w-1.5 bg-[#EE1D23] rounded-l" />

      {/* Icon */}
      <div className="absolute top-4 right-4 text-[#1A2B5C] opacity-30 group-hover:opacity-50 text-2xl">{icon}</div>

      <h3 className="text-sm font-medium text-[#1A2B5C] mb-1 uppercase tracking-wide">{title}</h3>

      <div className="text-3xl font-extrabold text-[#1A2B5C]">
        {loading ? '...' : (
          <>
            {cardData[dataKey] ?? '--'}
            {secondaryKey && ` | ${cardData[secondaryKey] ?? '--'}`}
          </>
        )}
      </div>

      <p className="text-xs text-gray-400 mt-3">Updated: {lastUpdated}</p>
    </motion.div>
  );

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center py-16">
          <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-[#1A2B5C]"></div>
        </div>
      ) : (
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
          initial="hidden"
          animate="visible"
        >
          {cardConfig.filter((config) => config.dataKey in cardData).map((config, index) => renderCard(config, index))}
        </motion.div>
      )}
    </div>
  );
};

export default Top17Cards;
